module.exports = __webpack_public_path__ + "images/emoji/octocat.11603b5f852fff5dac56.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/octocat.png
// module id = GCL+
// module chunks = 13